import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind);
    }

    onFontsLoaded() {
        setTimeout(() => {
            const breadcrumb = this.el.innerHTML
            document.querySelector('.c-header_breadcrumb').innerHTML = breadcrumb
        }, 200);
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
